import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLanguageContext } from "../../../../context/LanguageContext";
import IconSelect from "../../main/icon/IconSelect";
import { faFlag } from "@fortawesome/free-solid-svg-icons";

function LanguageSelectView({ options, value, onChange, disabled }) {
  const { translate } = useLanguageContext();

  return (
    <IconSelect
      options={options}
      value={value}
      onChange={onChange}
      disabled={disabled}
      title={translate("eva.main.entities.language")}
      icon={(value) => <FontAwesomeIcon icon={faFlag} />}
    />
  );
}

export default LanguageSelectView;
